import React from 'react';
import PageIntro from './PageIntro';
import Paragraph from './Paragraph';
import TabsOneColumnTextParagraph from './TabsOneColumnTextParagraph';
import TriggerQuestion from './triggerQuestion/TriggerQuestion';
import EventCountdownTimer from './EventCountdownTimer';
import Poll from './Poll';
import ActionButton from './ActionButton';
import SharePriceCardContainer from './SharePriceCardContainer';
import DividendCalculator from './DividendCalculator';
import OmDividendCardGroup from './DividendCardGroup';
const OneColumn = ({ oneColumnContent }) => {
    if (!oneColumnContent)
        return '';

    if (oneColumnContent.__typename === 'Contentstack_page_intro')
        return (<PageIntro pageIntroContent={oneColumnContent} />);

    if (oneColumnContent.__typename === 'Contentstack_one_column_text_paragraph')
        return (<Paragraph paragraphContent={oneColumnContent} />);

    if (oneColumnContent.__typename === 'Contentstack_tabs_one_column_text_paragraph')
        return (<TabsOneColumnTextParagraph tabsOneColumnTextParagraph={oneColumnContent} />);

    if (oneColumnContent.__typename === 'Contentstack_trigger_question') {
        return (<TriggerQuestion triggerQuestionContent={oneColumnContent} />)
    };

    if (oneColumnContent.__typename === 'Contentstack_event_countdown_timer') {
        return (<EventCountdownTimer eventCountdownTimerContent={oneColumnContent} />)
    };

    if (oneColumnContent.__typename === 'Contentstack_poll') {
        return (<Poll pollContent={oneColumnContent} />)
    };

    if (oneColumnContent.__typename === 'Contentstack_action_button') {
        return (<ActionButton actionButtonContent={oneColumnContent} />)
    };
    
    if (oneColumnContent.__typename === 'Contentstack_share_price_card_container') {
        return (<SharePriceCardContainer sharePriceContainerContent={oneColumnContent} />)
    };
    if (oneColumnContent.__typename === 'Contentstack_dividend_card_group') {
        return (<OmDividendCardGroup OmDividendCardGroupContent={oneColumnContent} />)
    };
    if (oneColumnContent.__typename === 'Contentstack_dividend_calculator') {
        return (<DividendCalculator dividendCalculatorContent={oneColumnContent} />)
    };

    return '';
}

export default OneColumn;